import useAppStore from "@/context/store";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import HBIcon from "../HBIcon";
import styles from "./index.module.less";

export default function AboutHeader() {
  const router = useRouter();
  const headerHeight = useAppStore((store) => store.headerHeight);

  return (
    <div className={styles.header} style={{ top: headerHeight }}>
      <Link
        href="/about"
        className={classNames([
          styles.item,
          router.pathname === "/about" ? styles.active : null,
        ])}
      >
        关于花瓣
      </Link>
      <Link
        href="/about/goodies"
        className={classNames([
          styles.item,
          router.pathname === "/about/goodies" ? styles.active : null,
        ])}
      >
        浏览器采集工具
      </Link>
      <Link
        href="/apps"
        className={classNames([
          styles.item,
          router.pathname === "/apps" ? styles.active : null,
        ])}
      >
        App下载
      </Link>
      <Link
        href="/about/contact"
        className={classNames([
          styles.item,
          router.pathname === "/about/contact" ? styles.active : null,
        ])}
      >
        联系我们
      </Link>
      <a
        className={styles.item}
        href="//support.qq.com/products/30852/faqs-more/#classifyId=80640"
        target="_blank"
        rel="noreferrer"
      >
        新手入门
        <HBIcon className={styles.icon} type="ic_open" />
      </a>
    </div>
  );
}
